import { makeStyles } from "tss-react/mui"

export const useStyles = makeStyles()(({ shadows }) => ({
  root: {},
  paper: {
    minWidth: "160px",
    borderRadius: "2px",
    boxShadow: shadows[6]
  }
}))
